import type { SizeProp } from '@fortawesome/fontawesome-svg-core'
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export function LoadingSpinner({ text, size = '1x' }: { text?: string; size?: SizeProp }) {
  return (
    <div className="loading-spinner" role="status">
      <FontAwesomeIcon icon={faCircleNotch} size={size} spin className="loading-spinner__icon" />
      {text ? <span className="loading-spinner__text">{text}</span> : <span className="visually-hidden">Loading</span>}
    </div>
  )
}
